import * as z from "zod";
//#region src/__generated__/files/final-decision-document/zod/finalDecisionDocumentDeleteRequestSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const finalDecisionDocumentDeleteRequestSchema = z.object({
	requestId: z.uuid(),
	fileId: z.uuid(),
	userId: z.uuid()
});
//#endregion
//#region src/__generated__/files/final-decision-document/zod/delete1Schema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const delete1Status200Schema = z.unknown();
const delete1ResponseSchema = delete1Status200Schema;
const delete1DataSchema = finalDecisionDocumentDeleteRequestSchema;
//#endregion
//#region src/__generated__/files/final-decision-document/zod/fileMetaDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const fileMetaDtoSchema = z.object({
	id: z.uuid(),
	parentId: z.uuid().nullish(),
	sourceId: z.uuid(),
	sourceType: z.enum([
		"PROJECT_ID",
		"WORK_GROUP",
		"MODEL_REPOSITORY",
		"CONTRACTOR_MANAGEMENT",
		"COSMOS",
		"COSMOS_FOR_DELETE",
		"COSMOS_FOR_MIGRATE",
		"ONTOLOGY_FILE_UPLOAD",
		"CLASSIFIER_TABLE_ROW",
		"ONTOLOGY_CLASSIFIER_TABLE",
		"ONTOLOGY_CATALOG_DEFINITION",
		"ONTOLOGY_SFO_DEFINITION",
		"MODEL_PROPERTIES",
		"EKPTD_RESOURCE",
		"EKPTD_ROLE_APPLICATION",
		"EKPTD_REJECT_ROLE_APPLICATION",
		"EKPTD_REVOKE_ROLE_APPLICATION",
		"LIBRARY",
		"KNOWLEDGE_BASE",
		"EXTERNAL_REQUEST",
		"INTERNAL_REQUEST",
		"INTERNAL_REQUEST_SUPPORTING",
		"INTERNAL_REQUEST_TU_PART",
		"INTERNAL_REQUEST_FINAL_DECISION"
	]),
	versionParentId: z.uuid().nullish().describe("Id первой версии этого файла. Присутствует только если поле version > 1"),
	version: z.int(),
	baseName: z.string(),
	size: z.int(),
	ext: z.string().nullish(),
	type: z.enum([
		"DIRECTORY",
		"DOCUMENT",
		"CLASSIFIER_DOCUMENT",
		"MODEL",
		"MODEL_DATA",
		"MODEL_DATA_SIMPLIFIED",
		"IMAGE",
		"COMMENT_DOCUMENT",
		"COSMOS_DOCUMENT",
		"COSMOS_GEOSERVER_DOCUMENT",
		"BUILDING_MANAGEMENT_DOCUMENT",
		"TASK_TRACKER",
		"MODEL_REPOSITORY",
		"CONTRACTOR_MANAGEMENT",
		"ONTOLOGY_DOCUMENT",
		"COLLISION_DOCUMENT",
		"ROLE_APPLICATION",
		"RESOURCE_DOCUMENT",
		"LIBRARY_DOCUMENT",
		"KNOWLEDGE_BASE_DOCUMENT",
		"REQUEST_DOCUMENT",
		"SUPPORTING_DOCUMENT"
	]),
	createdAt: z.iso.datetime(),
	modifiedAt: z.iso.datetime(),
	isDeleted: z.boolean(),
	isBlocked: z.boolean(),
	previewId: z.uuid().nullish(),
	preview: z.string().nullish().describe("Файл preview закодированный в base64. Поле может быть null, если для данного элемента не поддерживаются preview либо, если для данного элемента preview еще не было получено/сконвертировано."),
	author: z.uuid(),
	hash: z.string().nullish()
});
//#endregion
//#region src/__generated__/files/final-decision-document/zod/finalDecisionDocumentMetaRequestSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const finalDecisionDocumentMetaRequestSchema = z.object({
	requestId: z.uuid(),
	fileIds: z.array(z.uuid()).min(1).refine((items) => new Set(items).size === items.length, { message: "Array entries must be unique" })
});
//#endregion
//#region src/__generated__/files/final-decision-document/zod/meta1Schema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const meta1Status200Schema = z.array(fileMetaDtoSchema);
const meta1ResponseSchema = meta1Status200Schema;
const meta1DataSchema = finalDecisionDocumentMetaRequestSchema;
//#endregion
export { fileMetaDtoSchema as a, delete1Status200Schema as c, finalDecisionDocumentMetaRequestSchema as i, finalDecisionDocumentDeleteRequestSchema as l, meta1ResponseSchema as n, delete1DataSchema as o, meta1Status200Schema as r, delete1ResponseSchema as s, meta1DataSchema as t };

//# sourceMappingURL=meta1Schema.js.map